module.exports = __webpack_public_path__ + "static/media/exterior.85bf3bc3.svg";